// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8b6682a1","770":"7d96c207","955":"33386dd2"}[chunkId] + ".chunk.js";
};